import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const pages = [
  { label: "Accueil", path: "/", desc: "Carrelage et rénovation salle de bain en Valais" },
  { label: "Services", path: "/services", desc: "Tous nos services de carrelage et rénovation" },
  { label: "Contact & Devis", path: "/contact", desc: "Demandez un devis gratuit" },
  { label: "Politique de confidentialité", path: "/privacy", desc: "RGPD et protection des données" },
];

const localities = [
  { label: "Sion", path: "/sion" },
  { label: "Sierre", path: "/sierre" },
  { label: "Martigny", path: "/martigny" },
  { label: "Grône", path: "/grone" },
  { label: "Crans-Montana", path: "/crans-montana" },
  { label: "Verbier", path: "/verbier" },
  { label: "Nendaz", path: "/nendaz" },
  { label: "Vercorin", path: "/vercorin" },
  { label: "Nax", path: "/nax" },
];

export default function SitemapPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Plan du site | Carreaux-Bat Valais"
        description="Plan du site de Carreaux-Bat Valais. Retrouvez toutes les pages du site : services, localités, contact et politique de confidentialité."
        canonical="https://carreaux-bat.ch/sitemap"
        ogTitle="Plan du site — Carreaux-Bat Valais"
        ogDescription="Retrouvez toutes les pages du site Carreaux-Bat Valais."
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20">
        <img
          src="/images/sitemap-hero.jpg"
          alt="Plan du site"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <div className="flex items-center gap-2 text-sm text-white/60 mb-4">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white/80">Plan du site</span>
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">Plan du site</h1>
          <p className="text-white/60 text-sm">Retrouvez toutes les pages du site Carreaux-Bat Valais.</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          {/* Pages principales */}
          <div className="mb-12">
            <h2 className="text-lg font-bold text-stone-900 mb-4 flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center bg-amber-50 rounded-lg">
                <i className="ri-pages-line text-amber-700 text-sm"></i>
              </div>
              Pages principales
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {pages.map((p) => (
                <Link
                  key={p.path}
                  to={p.path}
                  className="flex items-center gap-3 p-4 bg-stone-50 rounded-lg hover:bg-amber-50 transition-colors group"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-white rounded-md group-hover:bg-amber-100 transition-colors">
                    <i className="ri-arrow-right-line text-stone-400 group-hover:text-amber-700 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-stone-900 group-hover:text-amber-800 transition-colors">{p.label}</p>
                    <p className="text-xs text-stone-500">{p.desc}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Localités */}
          <div>
            <h2 className="text-lg font-bold text-stone-900 mb-4 flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center bg-amber-50 rounded-lg">
                <i className="ri-map-pin-line text-amber-700 text-sm"></i>
              </div>
              Localités desservies
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {localities.map((l) => (
                <Link
                  key={l.path}
                  to={l.path}
                  className="flex items-center gap-3 p-4 bg-stone-50 rounded-lg hover:bg-amber-50 transition-colors group"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-white rounded-md group-hover:bg-amber-100 transition-colors">
                    <i className="ri-map-pin-2-line text-stone-400 group-hover:text-amber-700 text-sm"></i>
                  </div>
                  <p className="text-sm font-semibold text-stone-900 group-hover:text-amber-800 transition-colors">{l.label}</p>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}